import React from "react";
import { Link, StaticQuery, graphql } from "gatsby";
import Prose from "./utility/prose";

const Footer = () => (
  <StaticQuery
    query={graphql`
    query {
        site {
            siteMetadata {
                fullname
            }
        }
    }
    `}
    render={data => (
      <footer className="text-center bg-blue-50 dark:bg-neutral-800 px-4 py-12">
        <Prose>
          <div className="text-blue-900 dark:text-white pb-0 prose-a:text-inherit dark:prose-a:text-inherit">
            <p>&copy; {new Date().getFullYear()} {data.site.siteMetadata.fullname}<br />
              <Link className="text-inherit" to="/legal-notices-and-disclaimers">Legal Notices & Disclaimers</Link>
            </p>
            <p className="mb-0">Website provided by <a className="text-inherit" href="https://www.touchstonedistrictservices.com/" target="_blank" rel="noopener noreferrer">Touchstone</a></p>
          </div>
        </Prose>
      </footer>
    )} />
)

export default Footer
